export default __webpack_public_path__ + "static/media/user.b8aee714.svg";